import { useSelector } from "react-redux";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import { useFormatMessage } from "../Intl/Context";
import ButtonLink from "../Buttons/ButtonLink";

const AdminLink = props => {
  const t = useFormatMessage();
  const linkLabel = t(intlMessages.link);

  const { isAdmin, adminUrl } = useSelector(({ viewer }) => viewer);

  const adminLinkClassName = classNames([
    "position-fixed",
    "border-radius",
    "padding-xs",
    "btn-primary",
    "shadow-lg",
    "text-primary-inverse",
    "text-decoration-none",
    props.ClassName
  ]);

  if (!isAdmin || !adminUrl) return null;

  return (
    <ButtonLink
      href={adminUrl}
      label={linkLabel}
      id="admin-link"
      className={adminLinkClassName}
      target="_blank"
      rel="noopener noreferrer"
    />
  );
};

export default AdminLink;

const intlMessages = defineMessages({
  link: {
    id: "adminLink.link",
    defaultMessage: "Administration"
  }
});
